if (!customElements.get('lc-before-after-slider')) {
  class LcBeforeAfterSlider extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => this.handleClick(e));
    }

    async handleClick(e) {
      const singleButton = e.target.closest('.lc-add-single-btn');
      if (singleButton) {
        e.preventDefault();
        const variantId = singleButton.getAttribute('data-variant-id');
        if (!variantId) return;

        singleButton.classList.add('is-loading');
        singleButton.setAttribute('disabled', 'disabled');

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', {
            bubbles: true,
            detail: { sections: sectionsToBundle }
          })
        );

        const rootUrl = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.root_url) || '/';
        const payload = {
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1
          }],
          sections: sectionsToBundle
        };

        try {
          const response = await fetch(rootUrl + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(payload)
          });

          const state = await response.json();

          if (state.errors) {
            alert(state.errors);
          } else {
            const cartJson = await (
              await fetch(rootUrl + 'cart.js', {
                headers: {
                  'Content-Type': 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              })
            ).json();

            cartJson.sections = {};

            if (window.FoxTheme && window.FoxTheme.pubsub) {
              try {
                window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                  sources: 'lc-before-after-slider',
                  cart: cartJson
                });
              } catch (pubSubErr) {
                console.error(pubSubErr);
              }
            }

            const cartType = (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.cartType) || 'drawer';
            if (cartType === 'drawer') {
              document.dispatchEvent(new CustomEvent('cart:refresh', {
                detail: { open: true }
              }));
            } else {
              window.location.href = rootUrl + 'cart';
            }
          }
        } catch (err) {
          console.error(err);
        } finally {
          singleButton.classList.remove('is-loading');
          singleButton.removeAttribute('disabled');
        }
        return;
      }

      const button = e.target.closest('.lc-add-all-btn');
      if (!button) return;

      e.preventDefault();
      const variantIdsStr = button.getAttribute('data-variant-ids');
      if (!variantIdsStr) return;

      const variantIds = variantIdsStr.split(',').map(id => id.trim()).filter(id => id.length > 0);
      if (variantIds.length === 0) return;

      button.classList.add('is-loading');
      button.setAttribute('disabled', 'disabled');

      const items = variantIds.map(id => ({
        id: parseInt(id, 10),
        quantity: 1
      }));

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      const rootUrl = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.root_url) || '/';
      const payload = {
        items: items,
        sections: sectionsToBundle
      };

      try {
        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });

        const state = await response.json();

        if (state.errors) {
          alert(state.errors);
        } else {
          const cartJson = await (
            await fetch(rootUrl + 'cart.js', {
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
          ).json();

          cartJson.sections = {};

          if (window.FoxTheme && window.FoxTheme.pubsub) {
            try {
              window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                sources: 'lc-before-after-slider',
                cart: cartJson
              });
            } catch (pubSubErr) {
              console.error(pubSubErr);
            }
          }

          const drawer = button.closest('lookbook-card');
          if (drawer && typeof drawer.hide === 'function') {
            drawer.hide();
          }

          const cartType = (window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.cartType) || 'drawer';
          if (cartType === 'drawer') {
            document.dispatchEvent(new CustomEvent('cart:refresh', {
              detail: { open: true }
            }));
          } else {
            window.location.href = rootUrl + 'cart';
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
        button.classList.remove('is-loading');
        button.removeAttribute('disabled');
      }
    }
  }

  customElements.define('lc-before-after-slider', LcBeforeAfterSlider);
}
